import { BiSolidLock } from "react-icons/bi";
import { UpgradeLink } from "src/components/subscriptions/UpgradeLink";

export const LockOverlay = () => {
  return (
    <UpgradeLink className="absolute z-10 flex h-full w-full items-start justify-start p-2">
      <div className="rounded-full border border-gray-500 bg-gray-500 p-0.5">
        <BiSolidLock className="h-4 w-4 text-white" />
      </div>
    </UpgradeLink>
  );
};
